import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// Shared primitives

export const SectionLabel = ({ children, dark = false }) => (
  <span
    className={`inline-flex items-center gap-3 font-sans text-xs uppercase tracking-[0.24em] ${
      dark ? "text-citrine" : "text-slate"
    }`}
  >
    <span aria-hidden="true" className="h-px w-8 bg-citrine" />
    {children}
  </span>
);

export const CTALink = ({ to, children, variant = "primary", className = "", ...props }) => {
  const base =
    "inline-flex items-center gap-2 px-8 py-4 font-sans text-sm font-medium transition-[background-color,color,box-shadow,transform] duration-300 [transition-timing-function:cubic-bezier(0.22,1,0.36,1)] group focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-citrine focus-visible:ring-offset-2 active:translate-y-px";
  const styles = {
    primary: "bg-orange text-white shadow-elevated hover:bg-orange-dark hover:shadow-citrine",
    secondary: "border border-navy text-navy hover:bg-navy hover:text-white hover:shadow-elevated",
    secondaryLight: "border border-citrine/50 text-white hover:bg-white hover:text-navy hover:border-white",
  };
  return (
    <Link to={to} className={`${base} ${styles[variant]} ${className}`} {...props}>
      {children}
      <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={1.5} />
    </Link>
  );
};

export const Disclaimer = ({ children, className = "" }) => (
  <p className={`font-data text-xs text-slate leading-relaxed ${className}`} data-testid="illustrative-disclaimer">
    {children ||
      "*Illustrative estimate only, based on the assumptions above. Not a guarantee of returns. Mutual fund investments are subject to market risks; read all scheme related documents carefully."}
  </p>
);

export const Stat = ({ value, label }) => (
  <div className="border-t border-citrine/60 pt-5">
    <div className="font-data text-3xl md:text-4xl text-navy">{value}</div>
    <div className="font-sans text-xs uppercase tracking-[0.18em] text-slate mt-2">{label}</div>
  </div>
);
